export default "__VITE_ASSET__BGETW$RO__"